import Sidebar from '../Sidebar';
import React, { useState, useEffect } from "react";
import {RiMenuLine} from 'react-icons/ri';
import { Link ,NavLink } from "react-router-dom";
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";
import { useParams } from "react-router-dom"; 
import {FaEdit} from "react-icons/fa"
import Campaign from './Campaign';
import axios from "axios";
import Footer from "../Footer";
import {CopyToClipboard} from 'react-copy-to-clipboard';
import {FaRegCopy} from 'react-icons/fa'


const ViewCampaign=()=>{

  const [session ,setSession] = useState(false);

   const gesessiondata = async () => {
     debugger;
     axios.get('/checkSession')
      
     .then(result =>{
       if(result.data.code == 501){
         setSession(true)  ;
          }
      else{
        history.push("/");

      }
       debugger;
       console.log(result.data.code);
     }).catch(error =>{
       console.log(error);
     })
   };

//         console.log(session);

  useEffect(() => {
      gesessiondata();
    }, [session]);
    const [campaign ,setcampaign] = useState({
        id:"",
        name:"",
        startDate:"",
        endDate:"",
        calculatorName:"",
        createdDate: "",
        couponcode:"",
        totalvisitor:"",
        status:""
        });

        const {id} = useParams();
        useEffect(()=>{
            loadCampaign()
        },[])
    
    const loadCampaign = async () =>{
        const res = await axios.get(`/campaign/getCampaignById?id=${id}`);
        debugger;
        setcampaign(res.data.data);
        console.log("campign",res.data.data)
    }
    const sidebarCollapsed = localStorage.getItem('sidebar-collapsed');
      const [isExpanded ,setIsExpanded] = useState(sidebarCollapsed ? false :true);
      const handleToggler =()=>{
        if(isExpanded){
          setIsExpanded(false);
          localStorage.setItem('sidebar-collapsed',true);
         return;
       }
       setIsExpanded(true);
        localStorage.removeItem('sidebar-collapsed');
     }

     let history = useHistory();

     const redirect =()=>{

        history.push("/Campaign");
       }


       const [copyText, setCopyText] = useState(false);
  
    
    
    const copyLink = () => {
      debugger;
        //copy("hello my copy");
     setCopyText(true);
    }

  return (
<div className={ isExpanded ? " container" : "clpsMenu"}> 
          {/* <div className="container ">   */}
         <Sidebar isExpanded={isExpanded}></Sidebar>
         <div className={ isExpanded ? "sidebar-icon1 text_left" : "remanuLeftMargin"} >
         <RiMenuLine   className="rimwidthHeight" onClick={handleToggler}/>
         <span className="titlebar">Campaign</span>
        </div><br/><br/><br/>

        <div className={isExpanded?'subtitlebar':"subtitlebarclpse"}><span className='subtitlebartxt'>Campaign/ Campaign List/ View Campaign</span></div>

         <div className={isExpanded ? "usergrid" : "usergrid1"}>
          <div className='row'>
          <div className='col-3'></div>
         <div className="clientbtn  col-6">
            <div className="row displyflex">
            <div className='col-3'></div>
              <div className='col-6'>
                <span className="adclptag">View Campaign </span>
                 </div>
                 <div className='col-1'></div>

                 <div className='col-2'>
                 <Tippy content="Edit">

                 <NavLink className="" exact to={`/EditCampaign/${campaign.id}`}>
            <FaEdit color='#A47355' size="1.6em" className='editicon'/>
            </NavLink>
            </Tippy>
            </div>
            </div>
            </div> 
         <div className='col-2'></div> 
        </div> 

<br/><br/><br/>
<div className='form-group row'>
     <div className='col-3'></div>
     <div className='textright fontsize16 col-3'>
      <label for="campaignname">Campaign Name:</label>
      </div>
      <div className='col-4 textleft margintop6 colorfent'><span>{campaign.name}</span></div>
      <div className='col-2'></div>
</div>
<div className='form-group row'>
     <div className='col-3'></div>
     <div className='textright fontsize16 col-3'>
      <label for="campaignname">Created Date:</label>
      </div>
      <div className='col-4 textleft margintop6 colorfent'><span>{campaign.createdDate}</span></div>
      <div className='col-2'></div>
</div>
<div className='form-group row'>
     <div className='col-3'></div>
     <div className='textright fontsize16 col-3'>
      <label for="campaignname">Start Date:</label>
      </div>
      <div className='col-4 textleft margintop6 colorfent'><span>{campaign.startDate}</span></div>
      <div className='col-2'></div>
</div>
<div className='form-group row'>
     <div className='col-3'></div>
     <div className='textright fontsize16 col-3'>
      <label for="campaignname">End Date:</label>
      </div>
      <div className='col-4 textleft margintop6 colorfent'><span>{campaign.endDate}</span></div>
      <div className='col-2'></div>
</div>
<div className='form-group row'>
     <div className='col-3'></div>
     <div className='textright fontsize16 col-3'>
      <label for="campaignname">Health Calculator Name:</label>
      </div>
      <div className='col-4 textleft margintop6 colorfent'><span>{campaign.calculatorName}</span></div>
      <div className='col-2'></div>
</div>
<div className='form-group row'>
     <div className='col-3'></div>
     <div className='textright fontsize16 col-3'>
      <label for="campaignname">Status:</label>
      </div>
      <div className='col-4 textleft margintop6 colorfent'><span>{campaign.status}</span></div>
      <div className='col-2'></div>
</div>
<div className='form-group row'>
     <div className='col-3'></div>
     <div className='textright fontsize16 col-3'>
      <label for="campaignname">Link:</label>
      </div>
      <div className='col-4 textleft margintop6 colorfent'>
        <span>{campaign.link}</span>
        <CopyToClipboard text={campaign.link}>
           <button className='copylinkbtn' onClick={copyLink}><FaRegCopy size='1.4em' color='#A47355' className='copylinkicon'/></button>
       </CopyToClipboard>

        <label style={{marginLeft:30, color:"#A47355"}}>{copyText?"Copied":""}</label>
        </div>
      <div className='col-2'></div>
</div>



<br/><br/>
<div className='row'>
      <div className='col-5'></div>
      <div className='col-2'><button className='backbtn ' onClick={redirect}>Back</button></div>
      <br/>
      <div className='col-5'></div>

    </div>
<br/><br/><br/>

</div>

<div className={isExpanded ? "usermntmgtfooterexp" : "usermngmntfootercpls"}>  
   <Footer/> 
  </div> 
</div>
  );
}
 
export default ViewCampaign;